export const SIGN_IN_PATH = '/signin';
export const SIGN_IN_FLOW_ID = 'sign-in-magic-link';
